import validSupergitHIS from '../api/validSupergitHIS';

export class SupplyChainERPClient {
  constructor() {
    this.client = validSupergitHIS;
  }

  async getSuppliers(params) {
    const res = await this.client.get('/erp/suppliers', { params });
    return res.data;
  }

  async getSupplier(supplierId) {
    const res = await this.client.get(`/erp/suppliers/${supplierId}`);
    return res.data;
  }

  async createSupplier(data) {
    const res = await this.client.post('/erp/suppliers', data);
    return res.data;
  }

  async updateSupplier(supplierId, data) {
    const res = await this.client.put(`/erp/suppliers/${supplierId}`, data);
    return res.data;
  }

  async getItems(params) {
    const res = await this.client.get('/erp/items', { params });
    return res.data;
  }

  async getItem(itemId) {
    const res = await this.client.get(`/erp/items/${itemId}`);
    return res.data;
  }

  async createItem(data) {
    const res = await this.client.post('/erp/items', data);
    return res.data;
  }

  async updateItem(itemId, data) {
    const res = await this.client.put(`/erp/items/${itemId}`, data);
    return res.data;
  }

  async deleteItem(itemId) {
    const res = await this.client.delete(`/erp/items/${itemId}`);
    return res.data;
  }

  async getItemPackagingLevels(itemId) {
    const res = await this.client.get(`/erp/items/${itemId}/packaging-levels`);
    return res.data;
  }

  async createItemPackagingLevel(itemId, data) {
    const res = await this.client.post(`/erp/items/${itemId}/packaging-levels`, data);
    return res.data;
  }

  async updateItemPackagingLevel(itemId, levelId, data) {
    const res = await this.client.patch(`/erp/items/${itemId}/packaging-levels/${levelId}`, data);
    return res.data;
  }

  async deleteItemPackagingLevel(itemId, levelId) {
    const res = await this.client.delete(`/erp/items/${itemId}/packaging-levels/${levelId}`);
    return res.data;
  }

  async getPurchaseInvoices(params) {
    const res = await this.client.get('/erp/purchase-invoices', { params });
    return res.data;
  }

  async getPurchaseInvoice(invoiceId) {
    const res = await this.client.get(`/erp/purchase-invoices/${invoiceId}`);
    return res.data;
  }

  async createPurchaseInvoice(data) {
    const res = await this.client.post('/erp/purchase-invoices', data);
    return res.data;
  }

  async updatePurchaseInvoice(invoiceId, data) {
    const res = await this.client.put(`/erp/purchase-invoices/${invoiceId}`, data);
    return res.data;
  }

  async cancelPurchaseInvoice(invoiceId, reason) {
    const res = await this.client.post(`/erp/purchase-invoices/${invoiceId}/cancel`, { reason });
    return res.data;
  }

  async getPreOrders(params) {
    const res = await this.client.get('/erp/pre-orders', { params });
    return res.data;
  }

  async getPreOrder(preOrderId) {
    const res = await this.client.get(`/erp/pre-orders/${preOrderId}`);
    return res.data;
  }

  async getSaleInvoices(params) {
    const res = await this.client.get('/erp/sale-invoices', { params });
    return res.data;
  }

  async getSaleInvoice(invoiceId) {
    const res = await this.client.get(`/erp/sale-invoices/${invoiceId}`);
    return res.data;
  }

  async createSaleInvoice(data) {
    const res = await this.client.post('/erp/sale-invoices', data);
    return res.data;
  }

  async updateSaleInvoice(invoiceId, data) {
    const res = await this.client.put(`/erp/sale-invoices/${invoiceId}`, data);
    return res.data;
  }

  async cancelSaleInvoice(invoiceId, reason) {
    const res = await this.client.post(`/erp/sale-invoices/${invoiceId}/cancel`, { reason });
    return res.data;
  }

  async refundSaleInvoice(invoiceId, payload) {
    const res = await this.client.post(`/erp/sale-invoices/${invoiceId}/refund`, payload);
    return res.data;
  }

  async getCustomers(params) {
    const res = await this.client.get('/erp/customers', { params });
    return res.data;
  }

  async getLocations(params) {
    const res = await this.client.get('/erp/locations', { params });
    return res.data;
  }

  async getPurchasingDashboard() {
    const res = await this.client.get('/erp/purchasing-dashboard');
    return res.data;
  }

  async getPurchasingStats(params) {
    const res = await this.client.get('/erp/purchasing-stats', { params });
    return res.data;
  }

  async getCategories() {
    const res = await this.client.get('/erp/categories');
    return res.data;
  }

  async getUoms() {
    const res = await this.client.get('/erp/uoms');
    return res.data;
  }
}

export function getERPClient() {
  return new SupplyChainERPClient();
}

export default SupplyChainERPClient;
